import { useQuery } from 'react-query';
import { EXPRESS_API } from 'configs/api/expressApi';
import { emailVerificationKeys } from './emailVerificationKeys';
import { useToastError } from 'lib/hooks';
import { AxiosError } from 'axios';

interface EmailVerificationTokenResponse {
  valid: boolean;
}

const checkEmailVerificationToken = async (
  token: string
): Promise<EmailVerificationTokenResponse> => {
  return (await EXPRESS_API.get(`/email-verifications?token=${token}`)).data;
};

export const useCheckEmailVerificationToken = (
  token: string,
  enabled: boolean
) => {
  const { showError } = useToastError();
  return useQuery(
    emailVerificationKeys.token(),
    () => checkEmailVerificationToken(token),
    {
      refetchOnMount: true,
      onError: (err: AxiosError) => showError(err),
      enabled,
    }
  );
};
